import React from 'react'
import { Edit } from 'react-admin'

import MobileAppsForm from './form'

export const MobileAppsEdit = (props) => (
  <Edit undoable={false} {...props}>
    <MobileAppsForm isEdit={true} {...props} />
  </Edit>
)

export default MobileAppsEdit
